import React from "react";

export const LazySupportPage = React.lazy(() => import("./index"));
